import app from 'app';
import templateUrl from './submitClaimIncompleteBill.html';
import './submitClaimIncompleteBill.scss';

function SubmitClaimIncompleteBill() {
  const SubmitClaimIncompleteBill = this;

  SubmitClaimIncompleteBill.back = function () {
    SubmitClaimIncompleteBill.page = 'verify_bill';
  };
}

app.component('submitClaimIncompleteBill', {
  bindings: {
    page: '=',
  },
  controller: SubmitClaimIncompleteBill,
  controllerAs: 'SubmitClaimIncompleteBill',
  templateUrl,
});

export default 'submitClaimIncompleteBill';
